import { c as _c } from "react/compiler-runtime";
import { usePanelContext } from "../context";
import type { ReactNode } from "react";
import { DropdownMenuContent } from "@/components/ui/dropdown";
import { cx } from "@/lib/tailwind-utils";
import { FilterList } from "./filter-list";
import { QuickApply } from "./quick-apply";
import { Search } from "./search";
interface PanelProps {
  children?: ReactNode;
}
function DefaultPanelContents() {
  const $ = _c(10);
  const {
    searchQuery,
    searchInputFocused
  } = usePanelContext();
  let t0;
  if ($[0] !== searchInputFocused || $[1] !== searchQuery) {
    t0 = searchInputFocused && searchQuery.trim().length > 0;
    $[0] = searchInputFocused;
    $[1] = searchQuery;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const highlightFirstItem = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Search />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = highlightFirstItem && "[&>[role=menuitem]:first-child]:bg-hover [&>[role=menuitemcheckbox]:first-child]:bg-hover";
  let t3;
  if ($[4] !== t2) {
    t3 = cx("space-y-0.5", t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FilterList />;
    t5 = <QuickApply />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3) {
    t6 = <>{t1}<div className="max-h-[300px] overflow-y-auto p-1"><div className={t3}>{t4}{t5}</div></div></>;
    $[8] = t3;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}

/**
 * Default-composed dropdown panel: search input on top, filter type list and
 * quick-apply rows underneath. Pass `children` to opt out of the default
 * composition and assemble the parts manually.
 */
export function Panel(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = children ?? <DefaultPanelContents />;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <DropdownMenuContent className="mt-1.5 min-w-[280px] overflow-visible rounded-xl" align="start">{t1}</DropdownMenuContent>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}